'use client'

import { AlertCircle } from 'lucide-react'

export default function OtpErrorMessage({ message }: { message: string }) {
  return (
    <div className="flex items-center gap-2 rounded-lg border border-error-container bg-error-container/60 px-3 py-2 text-body-md text-destructive">
      <AlertCircle size={18} />
      <span>{message}</span>
    </div>
  )
}
